import React, { useState } from 'react'
import Button from '../../Components/Button/Button'
import { faTag } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MenuTitle from '../../Components/MenuTitlle/MenuTitle'
import Style from './AllProductDiscount.module.css'
import { AllDiscountProductApi } from '../../Api/BarestSupplierServices'
import { errorToast, succToast } from '../../Utils/Toast/Toast'

const AllProductDiscount = () => {
    const[percent,setPercent]=useState(true)
    const [inputTomanValue,setInputTomanValue]=useState('')
    const [inputPercentValue,setInputPercentValue]=useState('')

    const percentHandler = (e)=>{
        if(e==='درصد'){
            setPercent(true)
        }
        else{
            setPercent(false)
        }
        setInputPercentValue('')
        setInputTomanValue('')
    }

    const postAllProduct=()=>{
        const discount={
            id:0,
            product_id:0,
            const:inputTomanValue? parseInt(inputTomanValue):0,
            precentage:inputPercentValue ?parseInt(inputPercentValue) :0
        }
        AllDiscountProductApi(discount,(suc)=>{
            if(suc.status===1){
                succToast("با موفقیت ارسال شد") 
                setInputPercentValue('')
                setInputTomanValue('')
            }
            else{
                errorToast("مشکلی پیش آمده")
                setInputPercentValue('')
                setInputTomanValue('') 
            }
            
        }) 
    }
    
    const deleteCategoryDiscount=()=>{
        const Delete={
            id:0,
            product_id:0,
            const:0,
            precentage:0
        }
        AllDiscountProductApi(Delete,(suc)=>{
            if(suc.status===1){
                succToast("با موفقیت حذف شد ") 
                setInputPercentValue('')
                setInputTomanValue('')
            }
            else{
                errorToast("مشکلی پیش آمده")
                setInputPercentValue('')
                setInputTomanValue('') 
            }
            
        })
    }

    return (
        <div className={Style.pageHolder}>
            <MenuTitle title={"تخفیف کل محصولات"}/>
            <div className={Style.centerHolder}>
                <div className={Style.picHolder}>
                    <img src={"/Assets/Images/AllProductDiscount/disi.png"} alt=""/>
                </div>
                <section className={Style.discountPart}>
                   <p className={Style.discountTitle}><FontAwesomeIcon className={Style.discountIcon} icon={faTag} />اعمال تخفیف روی تمامی محصولات:</p>
                    <div className={Style.discountType}>
                       <h3 className={Style.text}>نوع تخفیف خود را مشخص کنید:</h3>
                        <select onChange={(e)=>{percentHandler(e.target.value)}} className={Style.typeHolder}>
                           <option value={"درصد"} className={Style.option}>درصد</option>
                           <option value={"وجه مالی"} className={Style.option}>وجه مالی</option>
                        </select>
                    </div>
                    <div>
                        {
                            percent ?
                            <div className={Style.discountAmountHolder}>
                                <FontAwesomeIcon className={Style.discountIcon} icon={faTag}/>
                                <h3 className={Style.mountTextfirst}>به مقدار</h3>
                                <input value={inputPercentValue} onChange={(e)=>setInputPercentValue(e.target.value)} type={"number"} className={Style.discountInput}/>
                                <h3 className={Style.mountTextSecond}>درصد تخفیف روی محصولات اعمال شود</h3> 
                            </div>
                            :
                            <div className={Style.discountTomanHolder}>
                                
                                <h3 className={Style.mountTextfirst}><FontAwesomeIcon className={Style.discountIconToman} icon={faTag}/>به مقدار</h3>
                                <input value={inputTomanValue} onChange={(e)=>setInputTomanValue(e.target.value)} type={"number"} className={Style.discountToman}/>
                                <h3 className={Style.mountTextSecond}>تومان تخفیف روی محصولات اعمال شود</h3> 
                            </div>
                        }
                    </div>
                    <div className={Style.btnHolder}>
                        <Button ClickHandler={postAllProduct} ClassBtn={"bigConfirmBtn"}  Value={"ثبت"}/>
                        <Button ClickHandler={deleteCategoryDiscount} ClassBtn={"bigConfirmBtn"} Value={"برداشتن تخفیف"}/>
                    </div>
                </section>
            </div>
        </div>
    )
}
export default AllProductDiscount